<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div class="moduleCard">
            <div v-show="mode==='0'">
              <div v-if="wtdata!==null">
                <div class="row mb-2">
                  <div class="col-12 text-right">
                    <input type="checkbox" v-model="includeExpired" @change="renderProducts(true)" /> <span id="include_expired_licenses">Include Expired Licenses </span>
                  </div>
                </div>
                <wondertable :wtID="'poolProducts'" id="tblProducts" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'This Pool Has No Products'" :defaultDirection="0"
                             :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Pool Products'" :burgerMenu="burgermenu" ref="wtRef"></wondertable>
              </div>
            </div>
            <div v-show="mode==='1'">
              <div class="row">
                <div class="col-6">
                  <h3 class="mt-2" id="invoice_purchase">Invoice Purchase</h3>
                </div>
                <div class="col-6 text-right">
                  <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon><span name="go_back"> Go Back</span></a>
                </div>
              </div>
              <hr />
              <invoicepurchase ref="ip" :products="wtdata" :pool="pool" :org="org" :canOverridePrice="canOverridePrice"></invoicepurchase>
            </div>
            <div v-show="mode==='2'">
              <div class="row">
                <div class="col-6">
                  <h3 class="mt-2" id="product_purchase_request">Product Purchase Request</h3>
                </div>
                <div class="col-6 text-right">
                  <a href="javascript:void(0)" @click="goBack"><font-awesome-icon icon="arrow-left" role="presentation"></font-awesome-icon><span name="go_back"> Go Back</span></a>
                </div>
              </div>
              <hr />
              <productpurchaserequest ref="purchaseRequest" :pool="pool"></productpurchaserequest>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div><acfooter></acfooter>
    <b-modal title="Members" id="members_model" ref="rPopList" scrollable ok-only size="xl">
      <div class="row" v-show="poplist!==null&&poplist.length>0">
        <div class="col-6">
          <b id="member_name">Member Name</b>
        </div>
        <div class="col-2">
          <b id="license_expiry">License Exp.</b>
        </div>
        <div class="col-2">
          <b id="assignment_date">Assign Date</b>
        </div>
        <div class="col-2">
          &nbsp;
        </div>
      </div>
      <div v-for="item in poplist" class="row">
        <div class="col-6 text-left" v-html="item.Name">

        </div>
        <div class="col-2">
          {{item.LicenseExpirationDate}}
        </div>
        <div class="col-2">
          {{item.ProductAssignmentDate}}
        </div>
        <div class="col-2 text-right">
          <button class="btn-transparent" @click="doDeleteMemberFromProduct(item.ClientID,item.LPPID)"><font-awesome-icon aria-label="Remove user" icon="times"></font-awesome-icon></button>
        </div>
      </div>
    </b-modal>
    <b-modal title="Add Free Licenses" id="add_free_licenses" ref="rFreeLicenses" size="xl" @ok="completeAddFreeLicenses">
      <div>
        <div class="row">
          <div class="col-4" id="product">
            Product:
          </div>
          <div class="col-8">
            <select v-model="freeLicenseProduct" class="fullWidth">
              <option v-for="pr in freeLicenses" v-bind:value="pr.ProductID">{{pr.ProductName}}</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-4" id="hash_licenses">
            # Licenses:
          </div>
          <div class="col-8">
            <input type="number" v-model.number="freeLicensesToAdd" />
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="products_model" title="Product Details" size="lg" ok-only ref="prDetails">
      <div v-if="productdetails!==null">
        <h3>{{productdetails.ProductName}}</h3>
        <div class="row">
          <div class="col-6" id="remaining">Remaining:</div>
          <div class="col-6">{{productdetails.Remaining}}</div>
        </div>
        <div class="row mt-2">
          <div class="col-6" id="hours">Hours:</div>
          <div class="col-6">{{productdetails.Hours}} </div>
        </div>
        <div class="row mt-2">
          <div class="col-6" id="term">Term:</div>
          <div class="col-6">{{productdetails.Term}} </div>
        </div>
        <div class="row mt-2">
          <div class="col-6" id="go_live">Go Live:</div>
          <div class="col-6">
            {{productdetails.GoLiveDate}}
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-6" id="max_expirations">Max Expiration:</div>
          <div class="col-6">{{productdetails.MaxExpDate}}</div>
        </div>
        <div class="row mt-2">
          <div class="col-6" id="trigger">Trigger:</div>
          <div class="col-6">{{productdetails.Trigger}}</div>
        </div>
        <div class="row mt-2">
          <div class="col-6" id="order_fill_date">Order Fill Date:</div>
          <div class="col-6">{{productdetails.OFill}}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
  import wondertable from "../../components/WonderTable.vue"
  import invoicepurchase from "../../components/InvoicePurchase.vue"
  import productpurchaserequest from "../../components/ProductPurchaseRequest.vue"
  export default {
    name: 'PoolProducts',
    components: { acheader, acfooter, poolsidebar, wondertable, invoicepurchase, productpurchaserequest },
    data() {
      return {
        burgermenu: [],
        canOverridePrice: null,
        freeLicenses: [],
        freeLicensesToAdd: 0,
        freeLicenseProduct: null,
        includeExpired: false,
        mode: '0',
        org: null,
        pool: null,
        poplist: [],
        productdetails: null,
        wids: ["LicensePoolProductID"],
        wtdata: null,
        wtmethods: {
          addFreeProducts: {
            method: function (param, ref) {
              ref.doAddFreeLicenses(param);
            },
            ref: this
          },
          addTrialLicenses: {
            method: function (param, ref) {
              ref.doAddTrialLicenses(param);
            },
            ref: this
          },
          doEdit: {
            method: function (param, ref) {
              ref.doEdit(param);
            },
            ref: this
          },
          doUsers: {
            method: function (param, ref) {
              ref.doUsers(param);
            },
            ref: this
          },
          invoiceLicenses: {
            method: function (param, ref) {
              ref.doInvoiceLicenses(param);
            },
            ref: this
          },
          purchaseLicenses: {
            method: function (param, ref) {
              ref.doPurchaseLicenses(param);
            },
            ref: this
          }
        }
      }
    },
    methods: {
      completeAddFreeLicenses() {
        try {
          if (Number.isInteger(this.freeLicensesToAdd) && this.freeLicensesToAdd > 0 && this.freeLicenseProduct !== this.emptyguid) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "AddProductFree",
                Fields: {
                  LicensePoolID: this.$route.params.id,
                  ProductID: this.freeLicenseProduct,
                  NumLicenses: this.freeLicensesToAdd
                }
              }
            ]).then(r => {
              this.popDialog(0, "Product added successfully");
              this.renderProducts(true);
            });
            return;
          }
        }
        catch (e) {
        }
        this.popDialog(1, "Please select a product and a number of licenses greater than 0");
      },
      doAddFreeLicenses() {
        this.apiCommand([
          {
            Operation: "Product",
            Function: "GetAllFreeTraining",
            Fields: {}
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          var fl = JSON.parse(cr.returnObjects[0].returnObject);
          fl.unshift({ ProductID: this.emptyguid, ProductName: "--- Select ---" });
          this.freeLicenses = fl;
          this.$refs["rFreeLicenses"].show();
          this.freeLicenseProduct = this.emptyguid;
          Window.loadLanguageContent();
        });
      },
      doAddTrialLicenses() {
        this.$bvModal.msgBoxConfirm('Add trial licenses? This wil add 100 trial licenses to any applicable trial products (if there are no trial products, nothing will happen)', {
          title: 'Confirm Add Trial Licenses',
          size: 'sm',
          id: "confirm_add_trial_licenses",
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([{
              Operation: "LicensePool",
              Function: "ApplyTrialLicenses",
              Fields: {
                LicensePoolID: this.$route.params.id
              }
            }]).then(r => {
              this.popDialog(0, "Trial licenses added (if applicable)");
              this.renderProducts(true);
            });
          }
          
        });

        Window.loadLanguageContent();
      },
      doDeleteMemberFromProduct(ClientID, LPPID) {
        if (confirm("Are you sure you want to remove this product from this member?")) {
          var self = this;
          this.apiCommand([
            {
              Operation: "LicensePool",
              Function: "DeleteMemberProduct",
              Fields: {
                LicensePoolID: this.$route.params.id,
                LicensePoolProductID: LPPID,
                ClientID: ClientID
              }
            }
          ]).then(r => {
            var cr = JSON.parse(r.CommandResult);
            if (cr.returnObjects[0].returnObject == "OK") {
              self.$refs["rPopList"].hide();
              self.popDialog(0, "Product removed successfully");
              self.renderProducts(true);
            }
            else {
              self.popDialog(1, cr.returnObjects[0].returnObject);
            }
          });
        }
      },
      doEdit(params) {
        this.productdetails = {};
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetLicenseDetails",
            Fields: {
              LicensePoolProductID: params.LicensePoolProductID,
              LicensePoolID: this.$route.params.id
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          var ld = JSON.parse(cr.returnObjects[0].returnObject);

          this.productdetails.OFill = "N/A";
          this.productdetails.Term = "N/A";
          this.productdetails.GoLiveDate = "N/A";
          this.productdetails.MaxExpDate = "N/A";
          this.productdetails.Trigger = "N/A";

          if (ld.Term !== null) {
            this.productdetails.Term = ld.Term;
          }
          if (ld.GoLiveDate !== null) {
            this.productdetails.GoLiveDate = ld.GoLiveDate === 0 ? "N/A" : ld.GoLiveDate;
          }
          if (ld.MaxExpDate !== null) {
            this.productdetails.MaxExpDate = this.buildDateTime(ld.MaxExpDate, false);
          }
          if (ld.Trigger !== null && ld.Trigger !== "") {
            this.productdetails.Trigger = ld.Trigger;
          }
          if (ld.OrderFillDate !== null) {
            this.productdetails.OFill = this.buildDateTime(ld.OrderFillDate, false);
          }
          this.productdetails.ProductName = ld.ProductName;
          this.productdetails.Remaining = ld.Remaining;
          this.productdetails.Hours = ld.Hours;

          this.$refs["prDetails"].show();
          this.$forceUpdate();
          Window.loadLanguageContent();
        });
      },
      doInvoiceLicenses() {
        this.mode = '1';
        this.$refs['ip'].reset();
      },
      doPurchaseLicenses() {
        this.mode = '2';
        this.$refs["purchaseRequest"].setup();
        Window.loadLanguageContent();        
      },
      doUsers(params) {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetUsersForProduct",
            Fields: {
              LicensePoolID: this.$route.params.id,
              LicensePoolProductID: params.LicensePoolProductID
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          var items = [];
          for (var member of JSON.parse(cr.returnObjects[0].returnObject)) {
            var lep = "N/A";
            var assdate = "N/A";
            if (member.AssignmentDate !== null) {
              assdate = this.buildDateTime(member.AssignmentDate, false);
            }
            if (member.LicenseType >= 3) {
              lep = this.buildDateTime(member.LicenseExpirationDate, false);
            }
            items.push({
              LPPID: params.LicensePoolProductID,
              ClientID: member.ClientID,
              ProductAssignmentDate: assdate,
              LicenseExpirationDate: lep,
              Name: this.buildSimUser(member.ClientID, member.Username, member.EmailAddress, member.FirstName, member.LastName, true, true)
            });
          }
          this.poplist = items;
          this.$refs["rPopList"].show();
          Window.loadLanguageContent();
        })
        
      },
      goBack() {
        this.mode = '0';
        this.renderProducts(true);
      },
      renderProducts(forceData) {
        this.apiCommand([
          {
            Operation: "LicensePool",
            Function: "GetProducts",
            Fields: {
              LicensePoolID: this.$route.params.id,
              ExcludeExpired: this.includeExpired === true ? "false" : "true",
              LanguageID: sessionStorage.getItem("userLanguageID")
            }
          }
        ]).then(r => {
          var cr = JSON.parse(r.CommandResult);
          var products = JSON.parse(cr.returnObjects[0].returnObject);
          this.pool = this.sdata.activepool;

          for (var dx = 0; dx < products.length; dx++) {
            products[dx].ProductExp = "NA";
            if (products[dx].LicenseType === 4 || products[dx].LicenseType === 3) {
              products[dx].ProductExp = products[dx].LicenseTerm + " Days";
            }
          }
          if (this.sdata.activepool.IsAdmin) {
            this.burgermenu = [
              [
                { text: 'Options', value: null },
                { html: "Add Free Products", value: "addFreeProducts" },
                { html: "Add Trial Licenses", value: "addTrialLicenses" },
                { html: "Product Purchase Request&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", value: "purchaseLicenses" }
              ]
            ]
            if (this.sdata.activeorg !== null && this.sdata.activeorg.CanPurchaseOnInvoice === true) {
              this.org = this.sdata.activeorg;
              this.canOverridePrice = this.sdata.activeorg.CanOverridePrice;
              this.burgermenu[0].push({ html: "Invoice Purchase", value: "invoiceLicenses" });
            }
          }
          if (forceData) {
            this.$refs["wtRef"].renderTable(products);
          }
          else {
            this.wtdata = products;
          }
        });
      }
    },
    mounted() {
      this.doPage().then(r => {
        this.bootstrapPool(this.$route.params.id);
        this.renderProducts(false);
        Window.loadLanguageContent();
      });
    }
  }
</script>
